<section id="admin-settings-page" class="settings-page" aria-labelledby="settings-overview-title">
  <header class="settings-page__header">
    <p class="settings-page__eyebrow">Administration</p>
    <h1 id="settings-overview-title">Verwaltung</h1>
    <p>Wählen Sie einen Bereich aus, um die zugehörigen Einstellungen zu bearbeiten.</p>
  </header>

  <div class="settings-grid">
    @for (item of settingsItems; track item.route) {
      <mat-card class="settings-card">
        <a class="settings-card__link" [routerLink]="item.route">
          <span class="settings-card__icon" aria-hidden="true">
            <mat-icon>{{ item.icon }}</mat-icon>
          </span>
          <span class="settings-card__content">
            <span class="settings-card__title">{{ item.label }}</span>
            <span class="settings-card__description">{{ item.description }}</span>
          </span>
          <mat-icon class="settings-card__arrow" aria-hidden="true">chevron_right</mat-icon>
        </a>
      </mat-card>
    }
  </div>
</section>
